import * as yup from "yup";

export const customerStatementDetailSchema = yup.object().shape({
  workOrderId: yup.string().default("").label("Work Order"),
  workOrder: yup.object().default({}).label("Work Order"),
});
